<!--
 * @Author: your name
 * @Date: 2020-04-30 20:14:01
 * @LastEditTime: 2025-04-23 16:08:16
 * @LastEditors: huguochi@mail.com zheng@sense.sg
 * @Description: In User Settings Edit
 * @FilePath: /nicee-h5/src/App.vue
-->

<template>
  <body id="app">
    <keep-alive>
      <!--这里是会被缓存的组件-->
      <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath" />
    </keep-alive>
    <!--这里是不会被缓存的组件-->
    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath" />
    <Popup
      v-if="couponList.length"
      :value="showFirstOrderReward"
      class="global-rp-notice"
      :close-on-click-overlay="false"
    >
      <div class="wrap-c">
        <div class="title">恭喜您獲得</div>
        <div class="line"></div>
        <img
          class="ribbon"
          :src="require('@/assets/image/background/ribbon.png')"
        />
        <div class="item" v-for="(item, index) in couponList" :key="index">
          <div class="left">
            <b>{{ item.couponAmount }}{{ $t('coins') }}</b>
            <div>{{ item.satisfyConditionDesc }}</div>
          </div>
          <div class="right">
            <b>{{
              item.couponName.includes('專屬優惠券')
                ? '陪玩师專屬優惠券'
                : item.couponName
            }}</b>
            <div>
              有效期至
              {{ new Date(item.deadlineTimestamp).$format('yyyy.MM.dd') }}
            </div>
          </div>
        </div>
        <button class="btn-get" @click="onClose">立即领取</button>
      </div>
      <button class="close-btn pointer" @click="onClose"></button>
    </Popup>
  </body>
</template>

<script>
import { Popup } from 'vant';
import { mapGetters, mapActions } from 'vuex';
import { getLanguage } from '@/i18n';
import { LocalStorageEventName } from '@/script/localStorage';

export default {
  filters: {
    splitTime(str) {
      return str ? str.split(' ')[0] : '';
    }
  },
  components: {
    Popup
  },
  computed: {
    ...mapGetters([
      'showNewerReward',
      'newDiscount',
      'userInfo',
      'accountInfo',
      'token'
    ]),
    couponList() {
      if (!this.accountInfo) return [];
      return (this.accountInfo.couponInfoList || [])
        .filter(item => {
          return (
            ['IMMEDIATE_DISCOUNT', 'EXCLUSIVE_COUPON'].includes(
              item.couponTemplate
            ) && item.couponStatus === 'EFFECT'
          );
        })
        .slice(0, 2);
    },
    userLanguage() {
      return this.userInfo && this.userInfo.language
        ? this.userInfo.language
        : '';
    }
  },
  data() {
    return {
      showFirstOrderReward: false,
      updateTime: null
    };
  },
  mounted() {
    console.log('當前環境', process.env);
    console.log('當前url', window.location.href);
    document.addEventListener('visibilitychange', this.listenDocumentVisible);
    window.addEventListener('storage', event => {
      // 检查事件是否是由 localStorage 引起的
      if (event.storageArea === localStorage) {
        // 获取存储事件的 key
        const key = event.key;
        if (
          key === LocalStorageEventName.language &&
          event.newValue != event.oldValue
        ) {
          // 获取存储事件的 newValue 和 oldValue
          const newValue = event.newValue;
          getLanguage(newValue);
        }
        if (
          key === LocalStorageEventName.deviceLanguage &&
          event.newValue != event.oldValue
        ) {
          // 获取存储事件的 newValue 和 oldValue
          const newValue = event.newValue;
          getLanguage(newValue, { source: 'app' });
        }
      }
    });
    this.initFontSize()
  },
  watch: {
    couponList() {
      if (this.couponList.length) {
        this.$http.get('/user/new/alert').then(({ data }) => {
          this.showFirstOrderReward = data;
        });
      }
    }
  },
  methods: {
    ...mapActions('user', ['setUser', 'setAccount']),
    initFontSize() {
      if(window.innerWidth >= 750){
        document.documentElement.style.fontSize = '100px';
      } else {
        document.documentElement.style.fontSize = '13.33333vw';
      }
    },
    jumpSkillList() {
      if (this.newDiscount.clickFn) this.newDiscount.clickFn();
      this.closeNewerReward();
    },
    closeNewerReward() {
      this.$store.dispatch('user/closeNewerReward');
    },
    onClose() {
      this.showFirstOrderReward = false;
    },
    listenDocumentVisible() {
      if (!document.hidden) {
        console.log('listenDocumentVisible');
        this.updateData();
      }
    },
    async updateData() {
      try {
        if (
          !this.updateTime ||
          new Date().getTime() - 60000 > this.updateTime.getTime()
        ) {
          console.log('update1');
          if (this.token) {
            await this.setUser();
            await this.setAccount();
            // if (this.userInfo && this.userInfo.language) {
            //   getLanguage(this.userInfo.language);
            // } else {
            //   getLanguage();
            // }
          }
        }
      } catch (error) {
        console.log(error);
      }
      this.updateTime = new Date();
    }
  },
  created() {
    window.addEventListener('resize', () => {
      this.initFontSize()
    });
    // 發現是無效調用，暫時屏蔽
    // try {
    //   this.$store.dispatch('skill/getQuickGame');
    // } catch (e) {
    //   console.error(e);
    // }
  },
  beforeDestroy() {
    document.removeEventListener(
      'visibilitychange',
      this.listenDocumentVisible
    );
  }
};
</script>

<style lang="scss">
@import './styles/reset.scss';
@import './styles/public.scss';
@import './styles/cssBox.scss';
@import './styles/color.scss';
@import './styles/theme.scss';
</style>

<style lang="scss" scoped>
.global-rp-notice {
  width: 578px;
  height: 720px;
  background: #df3a34;
  border-radius: 40px;
  padding: 60px 40px;
  &.van-popup {
    overflow: visible;
  }
  .wrap-c {
    @include flex(center, center, column);
  }
  .title {
    color: #ffdd1e;
    font-size: 44px;
    margin-bottom: 64px;
  }
  .line {
    height: 32px;
    width: 550px;
    border-radius: 32px;
    background: #a11711;
    position: absolute;
    top: 154px;
    left: 14px;
  }
  .ribbon {
    position: absolute;
    height: 464px;
    width: 746px;
    left: -80px;
    top: -80px;
    z-index: 1;
  }
  .item {
    position: relative;
    width: 526px;
    height: 144px;
    background: #fff;
    border-radius: 12px;
    margin-bottom: 16px;
    @include flex();
    .left {
      height: 144px;
      width: 194px;
      left: 112px;
      top: 596px;
      background: #fcf6e4;
      color: #ed7433;
      font-size: 28px;
      @include flex(center, center, column);
      b {
        font-size: 40px;
      }
    }
    .right {
      flex: 1;
      padding: 36px 24px;
      color: #999;
      font-size: 24px;
      height: 100%;
      @include flex(space-around, flex-start, column);
      b {
        font-size: 24px;
        color: #000;
      }
    }
  }
  .btn-get {
    background: linear-gradient(180deg, #ffdd1e 0%, #ffa51e 100%);
    height: 104px;
    width: 348px;
    left: 202px;
    top: 972px;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 72px;
    font-size: 32px;
  }
}
.use-reward {
  background: transparent;
  overflow: visible;
}
.reward-box-inner {
  background: url('~assets/image/background/newer-reward-bg.png') no-repeat
    center center;
  background-position: top center;
  width: 750px;
  height: 750px;
  background-size: contain;
  > div {
    @include flex(center, center, column);
  }
  .reward-btn {
    width: 212px;
    height: 74px;
    margin-top: 20px;
    margin-bottom: 12px;
    border-radius: 40px;
    background: $color-yellow;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 32px;
    line-height: 40px;
    color: #9b5a12;
  }
  p {
    margin-top: 12px;
    color: rgba(255, 255, 255, 0.7);
    font-size: 20px;
  }
  .close-btn {
    display: block;
    margin-top: 140px;
    width: 48px;
    height: 48px;
    background: url('~assets/image/icons/close-icon-border.png') no-repeat
      center center;
    background-size: contain;
  }
}
.title-1 {
  line-height: 74px;
  color: #feeab7;
  text-align: center;
  margin-top: 100px;
  font-size: 40px;
}
.title-2 {
  font-size: 40px;
  line-height: 68px;
  color: #feeab7;
  text-align: center;
}
.discount-price {
  display: flex;
  justify-content: center;
  font-weight: 800;
  font-size: 64px;
  line-height: 144px;
  text-align: center;
  color: #fa006e;
  margin-top: 50px;
  .amount {
    font-size: 160px;
    line-height: 240px;
    margin-left: 14px;
  }
}
</style>
